
export function HandPhoneMockup() {
  return (
    <div className="flex lg:justify-end group w-full relative perspective-1000 justify-center">
      {/* Decor Blobs behind phone */}
      <div className="-translate-x-1/2 -translate-y-1/2 -z-10 bg-gradient-to-tr from-blue-100/50 to-green-100/50 w-[120%] h-[120%] rounded-full absolute top-1/2 left-1/2 blur-3xl"></div>

      {/* The Phone Container - Back to original size */}
      <div className="relative w-[300px] h-[600px] sm:w-[340px] sm:h-[680px]">
        {/* Real Hand Image */}
        <div className="absolute inset-0 z-0 overflow-hidden rounded-[2.5rem] shadow-2xl">
          <img 
            src="https://images.unsplash.com/photo-1616348436168-de43ad0db179?w=1600&q=80" 
            alt="Hand holding phone" 
            className="object-center brightness-[1.02] w-full h-full object-cover"
          />
        </div>

        {/* Screen Overlay with requested Screenshot - Enlarged as requested */}
        <div className="absolute top-[5%] left-1/2 -translate-x-1/2 w-[105%] h-[92%] z-10 overflow-hidden flex items-center justify-center pointer-events-none">
          <img 
            src="/ausgabenliste-detail.webp" 
            alt="App Screenshot" 
            className="w-full h-full object-contain drop-shadow-2xl"
          />
        </div>

      </div>
      
      {/* Styles for hidden scrollbar */}
      <style>{`
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        .perspective-1000 { perspective: 1000px; }
      `}</style>
    </div>
  )
}
